import { render, staticRenderFns } from "./online.vue?vue&type=template&id=e942e464&scoped=true"
import script from "./online.vue?vue&type=script&lang=js"
export * from "./online.vue?vue&type=script&lang=js"
import style0 from "./online.vue?vue&type=style&index=0&id=e942e464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e942e464",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default})
